import React from 'react';
import Alert from './Alert';
import classNames from 'classnames';
import {SUCCESS__24} from '@homeaway/svg-defs';
import './AlertSuccess.less';

function AlertSuccess(props) {
    let buttonClasses = classNames('Alert--success', props.className);
    return (
        <Alert {...props} className={buttonClasses} svgClassName="Alert__svg--success"/>
    );
}

AlertSuccess.propTypes = {
    ...Alert.propTypes
};

AlertSuccess.defaultProps = {
    ...Alert.defaultProps,
    svgMarkup: SUCCESS__24
};

export default AlertSuccess;
